export default {
  name: "",
  inSwitch: false,
  idMainTenant: null,
  idInSwitch: null,
  nameMainTenant: "",
  modalRef: ""
};
